import { DowncastDispatcher, DowncastInsertEvent, Element, Plugin, ViewElement } from 'ckeditor5';

class TableAttributesPlugin extends Plugin {
  init() {
    this.editor.conversion.for('downcast').add((dispatcher: DowncastDispatcher) => {
      dispatcher.on<DowncastInsertEvent<Element>>('insert:table', (_, data, conversionApi) => {
        const viewWriter = conversionApi.writer;
        const figure = conversionApi.mapper.toViewElement(data.item);
        const table = figure!.getChild(0) as ViewElement;

        viewWriter.setAttribute('border', '1', table);
        viewWriter.setAttribute('cellpadding', '1', table);
        viewWriter.setAttribute('cellspacing', '1', table);
      });
    });
  }
}

export default TableAttributesPlugin;
